
import { useState, useEffect } from 'react';
import { useAuth } from '@/components/auth/AuthProvider';

export const useAdminAuth = () => {
  const { user, profile } = useAuth();
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  useEffect(() => {
    // Check if user is authenticated and has admin role
    setIsCheckingAuth(false);
  }, [user, profile]);

  // SECURITY: SMS authentication never grants admin privileges
  // Only Supabase-authenticated users with admin profiles can access admin features
  const supabaseAdmin = Boolean(user && profile?.role === 'admin');
  
  // Clean up any old SMS admin auth tokens
  const cleanupOldTokens = () => {
    const oldSmsAdmin = localStorage.getItem('sms_admin_auth');
    if (oldSmsAdmin) {
      console.log('🔒 Removing deprecated SMS admin token');
      localStorage.removeItem('sms_admin_auth');
    }
  };
  
  // Clean up old tokens on every check
  cleanupOldTokens();
  
  console.log('👑 Admin authentication state:', {
    supabaseAdmin,
    user: !!user,
    profile: profile?.role,
    timestamp: new Date().toISOString()
  });

  // SECURITY: Only Supabase admin authentication is valid
  const isAdminAuthenticated = Boolean(supabaseAdmin);

  const authenticateAdmin = () => {
    // This function is no longer needed as authentication is handled by Supabase
    console.warn('Admin authentication is now handled through Supabase auth');
  };

  const signOutAdmin = () => {
    // Clean up any old localStorage data for security
    localStorage.removeItem('admin_auth');
    localStorage.removeItem('admin_pin');
  };

  return {
    isAdminAuthenticated,
    isCheckingAuth,
    authenticateAdmin,
    signOutAdmin
  };
};
